import { Stack, Text, Title } from '@mantine/core';
import { Card } from './card';
import { CenteredLayout } from './centered-layout';
import { LogoutButton } from './logout-button';

export function UnauthorizedMessage() {
  return (
    <CenteredLayout>
      <Card sx={{ width: 420 }}>
        <Stack spacing="lg" align="center">
          <Title order={3}>Access denied</Title>
          <Text color="dimmed" size="sm" align="center">
            This app is restricted to admin users. Sign in with an admin account to continue.
          </Text>
          <LogoutButton />
        </Stack>
      </Card>
    </CenteredLayout>
  );
}
